module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Bold.ad546b47.woff2";